import React from 'react';

import { Skeleton } from '@atlaskit/avatar';

const AvatarSkeletonSquareExample = (): React.JSX.Element => {
	return <Skeleton appearance="square" />;
};

export default AvatarSkeletonSquareExample;
